import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../api/client';

/**
 * Lightweight analytics hook that tracks page views.
 * Fires on every route change, debounced to avoid rapid duplicate events.
 */
export function usePageTracking() {
  const location = useLocation();
  const lastPath = useRef('');

  useEffect(() => {
    const path = location.pathname;
    if (path === lastPath.current) return;
    lastPath.current = path;

    // Derive feature name from path
    const feature = path.replace(/^\//, '').split('/')[0] || 'dashboard';

    // Fire and forget — don't block UI
    const token = localStorage.getItem('token');
    if (!token) return;

    api.post('/api/v1/product-analytics/track', {
      feature,
      action: 'view',
      metadata: { path },
    }).catch(() => {});
  }, [location.pathname]);
}
